<template>
  <div class="home-news-center" ref="homeNewsCenter">
    <img loading="lazy" class="home-news-center-bg" src="@/assets/img/home/newsCenterImg1.png" alt="">
    <Transition enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
      <img loading="lazy" class="title animate__animated" v-if="offsetTop < 650"
        src="@/assets/img/home/newsCenterText1.png" alt="">
    </Transition>
    <div class="news-container">
      <div class="news-container-part">
        <div v-for="item in wrNewsList" :key="item.id" class="news-item"
          @click="$router.push({ name: `/newsDetails`, params: item })">
          <div class="round-dot"></div>
          <div class="news-title ellipsis">{{ item.title }}</div>
          <div class="publish-time ellipsis">{{ moment(item.publishTime).format('YYYY-MM-DD') }}</div>
          <div class="details ellipsis">{{ '详情' }}</div>
        </div>
      </div>
      <div class="news-container-part">
        <div v-for="item in industryNewsList" :key="item.id" class="news-item"
          @click="$router.push({ name: `/newsDetails`, params: item })">
          <div class="round-dot"></div>
          <div class="news-title ellipsis">{{ item.title }}</div>
          <div class="publish-time ellipsis">{{ moment(item.publishTime).format('YYYY-MM-DD') }}</div>
          <div class="details ellipsis">{{ '详情' }}</div>
        </div>
      </div>
    </div>
    <el-button class="view-more-btn" type="primary" plain round size="medium"
      @click="$router.push('/newsCenter')">查看更多</el-button>
    <div></div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: '',
  components: {

  },
  props: ['offsetTop'],
  data() {
    return {
      wrNewsList: [],
      industryNewsList: [],
      queryInfo: {
        pageSize: 6,
        pageNum1: 1,
        category: ''
      },
      moment,
    }
  },
  created() {
    this.getNewsData()
  },
  mounted() {

  },
  methods: {
    async getNewsData() {
      const res1 = this.$apis.news_list({ ...this.queryInfo, category: '沃瑞新闻' })
      const res2 = this.$apis.news_list({ ...this.queryInfo, category: '行业新闻' })
      try {
        const result = await Promise.all([res1, res2])
        this.wrNewsList = result[0].data.records
        this.industryNewsList = result[1].data.records
      } catch (error) {
        console.log(error);
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.home-news-center {
  position: relative;
  height: 62.5rem;
  display: flex;
  justify-content: center;

  .home-news-center-bg {
    width: 120rem;
    height: 62.5rem;
  }

  .title {
    width: 43.25rem;
    height: 5.0625rem;
    position: absolute;
    top: 5rem;
  }

  .news-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 3.75rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .news-container-part {
      display: grid;
      grid-template-rows: repeat(6, 1fr);
      row-gap: 50px;

      .news-item {
        width: 37.5rem;
        min-width: 22.5rem;
        height: 3rem;
        background: rgba(0, 150, 255, 0.6);
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: box-shadow, transform;
        transition-property: box-shadow, transform;
        border-radius: 2rem;
        display: flex;
        align-items: center;
        letter-spacing: 1px;
        color: #FFFFFF;
        text-align: left;
        cursor: pointer;
        font-family: FZLanTingHei-R-GBK;
        font-weight: 400;
        color: #FFFFFF;
        font-size: 1.25rem;

        &:hover,
        :focus {
          box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
          -webkit-transform: scale(1.1);
          transform: scale(1.1);
        }

        .round-dot {
          width: 0.9375rem;
          height: 0.9375rem;
          border-radius: 50%;
          background-color: #FFFFFF;
          margin-left: 1.5625rem;
        }

        .news-title {
          width: 280px;
          margin-left: 20px;
          text-overflow: ellipsis;

        }

        .publish-time {
          margin-left: auto;
          width: 135px;
        }

        .details {
          margin: 0 1.25rem;
          min-width: 2.1875rem;
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            color: aqua;
          }
        }

      }
    }




  }

  .view-more-btn {
    position: absolute;
    background: transparent;
    color: #FFFFFF;
    border-color: #FFFFFF;
    right: 17.75rem;
    bottom: 6.5rem;
  }

  .view-more-btn:hover {
    color: #0096FF;
    border-color: #0096FF;
  }


}
</style>